import { Box, Typography } from '@mui/material';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';

import JxIconButton from '../../../JxControls/JxButtons/JxIconButton.jsx';
import JxTooltip from '../../../JxControls/JxTooltips/JxTooltip.jsx';
import { useUserSetting } from '../../../contexts/UserSettingsContext.jsx';
import { emsToDisplay } from '../../../services/utils/DateFormat.js';
import deleteConfirmEngine from '../../../components/shared/DeleteConfirmEngine';
import umlPreviewEngine from '../../Core/Preview/UmlPreviewEngine';
import './LoadUmlNoteRow.css';

/**
 * LoadUmlNoteRow — one selectable UmlSchema note. item is a journal note whose
 * body holds the shapes/connectors. Card styling from entry-row-* shared classes
 * (see FormConfigItemRow.css), remark/updated text plain jx-panel default (same
 * as UmlSchemaStartTab's .usd-start-text) — not service/topic, since every
 * UmlSchema note lives in the same topic and there's no UI to change that.
 * @param {{ item: object, isSelected: boolean, onSelect: Function }} props
 */
export default function LoadUmlNoteRow({ item: note, isSelected, onSelect }) {
    const chipDateTimeFormat = useUserSetting('contentPanel.chipDateTimeFormat');
    const showPreview = useUserSetting('umlWorkspace.showPreviewInLoadDlg');
    const isDeleted = note.stateId === 999;
    const preview = showPreview ? umlPreviewEngine.getPreview(note.rk) : null;

    /**
     * Opens the app-wide delete confirmation for this note.
     * @param {React.MouseEvent} e
     */
    const handleDelete = (e) => {
        e.stopPropagation(); // don't trigger onSelect
        deleteConfirmEngine.request(note);
    };

    return (
        <Box id={`UmlSchemaItemRow-${note.rk}`} className="entry-row-wrapper">
            <Box
                id={`entry-row-${note.rk}`}
                className={`entry-row-card ${isSelected ? 'entry-row-card--selected' : ''}`}
                onClick={() => onSelect(note)}
            >
                <Box className="usird-title-line">
                    <Typography
                        className={`entry-row-title usird-title ${isSelected ? 'entry-row-title--selected' : ''}`}
                        sx={isDeleted ? { textDecoration: 'line-through', opacity: 0.5 } : {}}
                    >
                        {note.title || '(no name)'}
                    </Typography>

                    <JxTooltip title="Delete">
                        <JxIconButton
                            icon={<DeleteOutlineIcon sx={{ fontSize: 16 }} />}
                            onClick={handleDelete}
                            className="usird-delete"
                        />
                    </JxTooltip>
                </Box>

                {note.remark && (
                    <Typography className="usird-remark" sx={isDeleted ? { textDecoration: 'line-through' } : {}}>
                        {note.remark}
                    </Typography>
                )}

                {preview && <img className="usird-thumb" src={preview.body} alt="" />}

                <Typography className="usird-updated">{emsToDisplay(note.updatedOn, chipDateTimeFormat)}</Typography>
            </Box>
        </Box>
    );
}
